import { uri } from '../../api-endpoint';
import {
  IProjectAPIValidationError,
  IProjectFromAPISuccessResponse
} from '../../type-conversion/project/from-api-repsonse';
import { ProjectAPIRequestBody } from '../../type-conversion/project/to-api-request-body';
import { createTemplateFn } from '../common';

export const createProject = (token: string) => (companyId: number) =>
  createTemplateFn(
    token,
    uri.projectListOfCompany(companyId),
    ProjectAPIRequestBody,
    IProjectFromAPISuccessResponse,
    IProjectAPIValidationError
  );
